// import ApiService from '@/services/api.services'
import ApiService from '../api.service'
import { TokenService } from '@/services/storage.service'

const QteTemplateService = {
    searchQuoteTemplates: async (payload) => {
        const url = `/api/QuoteTemplate/SearchQuoteTemplates`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    getQuoteTemplateForEdit: async (payload) => {
        const url = `/api/QuoteTemplate/GetQuoteTemplateForEdit`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    saveQuoteTemplate: async (payload) => {
        const url = `/api/QuoteTemplate/SaveQuoteTemplate`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    updateQuoteTemplateItems: async (payload) => {
        const url = `/api/QuoteTemplate/UpdateQuoteTemplateItems`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    insertQuoteTemplateItem: async (payload) => {
        const url = `/api/QuoteTemplate/InsertQuoteTemplateItem`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
}

export default QteTemplateService